import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["data-job-id"]
const _hoisted_2 = { class: "jobs-panel-list-item__colored-wrap" }
const _hoisted_3 = { class: "jobs-panel-list-item__header" }
const _hoisted_4 = { class: "jobs-panel-list-item__header-workers" }
const _hoisted_5 = { class: "jobs-panel-list-item__header-divider" }
const _hoisted_6 = { class: "jobs-panel-list-item__header-options" }
const _hoisted_7 = {
  key: 0,
  class: "jobs-panel-list-item__actions"
}
const _hoisted_8 = { class: "jobs-panel-list-item__body" }
const _hoisted_9 = { class: "jobs-panel-list-item__body-message" }
const _hoisted_10 = ["onClick", "innerHTML"]
const _hoisted_11 = ["onClick", "innerHTML"]
const _hoisted_12 = ["href", "onClick", "innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "jobs-panel-list-item__additions"
}
const _hoisted_16 = { class: "jobs-panel-list-item__addition-header" }
const _hoisted_17 = { class: "jobs-panel-list-item__addition-user" }
const _hoisted_18 = { class: "jobs-panel-list-item__addition-date" }
const _hoisted_19 = { class: "jobs-panel-list-item__addition-message" }
const _hoisted_20 = { class: "jobs-panel-list-item__addition-title" }
const _hoisted_21 = ["onClick", "innerHTML"]
const _hoisted_22 = ["onClick", "innerHTML"]
const _hoisted_23 = ["href", "onClick", "innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "jobs-panel-list-item__comment-label" }
const _hoisted_27 = { class: "jobs-panel-list-item__comment-input" }
const _hoisted_28 = {
  key: 3,
  class: "jobs-panel-list-item__body-project"
}
const _hoisted_29 = { class: "jobs-panel-list-item__body-project-text" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 4,
  class: "jobs-panel-list-item__body-project"
}
const _hoisted_32 = { class: "jobs-panel-list-item__body-project-text" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 0,
  class: "jobs-panel-list-item__body-project-divider"
}
const _hoisted_35 = { class: "jobs-panel-list-item__footer" }
const _hoisted_36 = { class: "jobs-panel-list-item__footer-left" }
const _hoisted_37 = {
  key: 2,
  class: "jobs-panel-list-item__footer-left-options-files-block-items"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 2,
  class: "jobs-panel-list-item__footer-left-options-tags"
}
const _hoisted_40 = {
  key: 1,
  class: "jobs-panel-list-item__footer-left-options-tags-plain"
}
const _hoisted_41 = {
  key: 3,
  class: "jobs-panel-list-item__footer-left-options-date"
}
const _hoisted_42 = {
  key: 0,
  class: "jobs-panel-list-item__footer-bottom"
}

import {
	computed,
	ref
} from 'vue'
import { useFileDrop, MAX_FILES_PER_BATCH } from "@/composables/useFileDrop";
import { useNotification } from "@/composables/useNotification";
import { useUploadQueue } from "@/composables/useUploadQueue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import FileInfoModal from "@/components/file/modals/FileInfoModal.vue";
import JobInfoModal from "@/components/main/jobs-panel/modals/JobInfoModal.vue";
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue";
import {
	Job,
	JobFile,
	jobsStore
} from "@/store/jobs";
import {JobStatus} from "@/models/etc/types";
import {FileApi} from "@/ api/FileApi";
import {workerStore} from "@/store/worker";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import JobsOptionsDropdown from "@/components/main/jobs-panel/dropdowns/JobsOptionsDropdown.vue";
import CreateEditJobDropdown from "@/components/main/jobs-panel/dropdowns/CreateEditJobDropdown.vue";
import DeleteJobConfirmDropdown from "@/components/main/jobs-panel/dropdowns/DeleteJobConfirmDropdown.vue";
import {
	highlightSearchText,
	escapeHtml,
	stripHighlightMarkup,
	trimTrailingLineBreaks
} from "@/utils/textHelpers";
import { i18n, tp } from "@/i18n";
import {useRoute, useRouter} from "vue-router";
import {TagEntityType} from "@/models/etc/types";
import type {TagWithFrequency} from "@/models/interfaces/tags/tag-models";
import {searchStore} from "@/store/search";
import {splitTextByPhoneNumbers} from "@/utils/contactsHelpers";
import {normalizeUrlForOpening} from "@/utils/urlHelpers";
import {PersonApi} from "@/ api/PersonApi";
import ContactsEmailPhoneOptionsDropdown
	from "@/components/main/clients-panel/dropdowns/ContactsEmailPhoneOptionsDropdown.vue";
import {useJobsAccess} from "@/composables/useJobsAccess";
import {useJobWorkerOptions} from "@/composables/useJobWorkerOptions";
import {getJobDeadlineState} from "@/utils/jobDeadline";
import { projectPageStore } from "@/store/project-page";
import { clientPageStore } from "@/store/client-page";

const MAX_SIZE_MB = 100

type JobAction = 'endByWorker' | 'sendToChecking' | 'sendToReworking' | 'endByAdmin'


export default /*@__PURE__*/_defineComponent({
  __name: 'JobsPanelListItem',
  props: {
    job: {}
  },
  setup(__props: any) {

const route = useRoute()
const router = useRouter()

const t = (key: string, named?: Record<string, unknown>): string => {
	return String(named ? i18n.global.t(key, named) : i18n.global.t(key))
}

const {isJobsReadonly} = useJobsAccess()
const projectStore = projectPageStore()
const clientStore = clientPageStore()

const fileAccessLevel = computed(() => {
	if (route.query.page === 'client') {
		return clientStore.openedClient?.FileAccess ?? 0
	}
	if (route.query.page === 'project') {
		return projectStore.openedProject?.FileAccess ?? 0
	}
	return 0
})

const hasFileAccessContext = computed(
	() => route.query.page === 'client' || route.query.page === 'project'
)

const hasFileAccess = computed(
	() => !hasFileAccessContext.value || fileAccessLevel.value !== 0 || isAdmin.value
)

const canManageJobFiles = computed(
	() => !hasFileAccessContext.value || fileAccessLevel.value === 2 || isAdmin.value
)

const props = __props;

const $job = ref<HTMLElement>()
const $uploadFile = ref<HTMLInputElement>()
const $fileInfoModal = ref<typeof FileInfoModal | null>(null);
const $jobInfoModal = ref<InstanceType<typeof JobInfoModal> | null>(null);
const $optionsDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $editJobDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $deleteJobDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $addTagDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const store = jobsStore()
const searchStoreInstance = searchStore()
const isLoading = ref(false);
const showAllFiles = ref(false);

const notify = useNotification()
const uploadQueue = useUploadQueue()

const {
	isDraggingOver,
	canDrop,
	validateFile,
	handleDragOver,
	handleDragEnter,
	handleDragLeave,
	handleDrop,
} = useFileDrop({
	maxSizeMb: MAX_SIZE_MB,
	maxFiles: MAX_FILES_PER_BATCH,
	multiple: true,
	onError: (message) => notify.danger(t('files_label'), message),
	onFiles: async (files) => {
		enqueueDeviceUpload(files)
	},
	onProjectFiles: async (files) => {
		await attachProjectFiles(files)
	},
})

const jobTagsModel = computed<TagWithFrequency[]>(
	() => (props.job.Tags ?? []) as unknown as TagWithFrequency[]
)

const tagsReadonlyText = computed(() =>
	(props.job.Tags ?? []).map(t => t.Name.toLowerCase()).join(', ')
)

const onTagSelectorChange = async (nextTags: TagWithFrequency[]) => {
	if (isJobsReadonly.value) {
		return
	}
	const prevIds = new Set((props.job.Tags ?? []).map(t => t.Id))
	const nextIds = new Set(nextTags.map(t => t.Id))
	const added = nextTags.filter(t => !prevIds.has(t.Id))
	const removedIds = [...prevIds].filter(id => !nextIds.has(id))
	try {
		for (const tag of added) {
			await store.attachTagToJob(props.job.Id, tag.Name)
		}
		for (const id of removedIds) {
			await store.detachTagFromJob(props.job.Id, id)
		}
	} catch (e) {
		console.error(e)
	}
}

const onCreateTag = async (name: string) => {
	if (isJobsReadonly.value) {
		return
	}
	try {
		await store.attachTagToJob(props.job.Id, name)
	} catch (e) {
		console.error(e)
	}
}

const onDetachTag = async (tagId: number) => {
	if (isJobsReadonly.value) {
		return
	}
	try {
		await store.detachTagFromJob(props.job.Id, tagId)
	} catch (e) {
		console.error(e)
	}
}

const { workersOptions: optionsPersons } = useJobWorkerOptions()

const handleEdit = () => {
	$optionsDropdown.value?.close()
	$editJobDropdown.value?.open()
}

const enqueueDeviceUpload = (files: File[]) => {
	uploadQueue.enqueue(files, (file, hooks) =>
		store.attachJobFileFromDevice(file, props.job.Id, hooks)
	)
}

const notifyAttachResult = (ok: number, fail: number) => {
	if (ok > 0 && fail === 0) {
		notify.success(t('files_label'), tp('file_attached_count', ok))
	} else if (ok > 0 && fail > 0) {
		notify.warning(t('files_label'), t('file_attach_partial', { ok, fail }))
	} else if (fail > 0) {
		notify.danger(t('files_label'), tp('file_attach_failed_count', fail))
	}
}

const attachProjectFiles = async (files: { Id: number; Name: string; Signed: boolean }[]) => {
	let ok = 0
	let fail = 0
	try {
		isLoading.value = true
		for (const f of files) {
			try {
				await store.attachJobFileFromClientOrProject(props.job.Id, f.Id, {
					Id: f.Id,
					Name: f.Name,
					Signed: f.Signed,
				})
				ok++
			} catch (e) {
				console.error(e)
				fail++
			}
		}
	} finally {
		isLoading.value = false
	}
	notifyAttachResult(ok, fail)
}

const detachFile = async (file: JobFile) => {
	if (isJobsReadonly.value) {
		return
	}
	try {
		isLoading.value = true
		await store.detachJobFile(props.job.Id, file.Id)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const showFileInfo = async (file: JobFile) => {
	if (!hasFileAccess.value) return

	try {
		isLoading.value = true
		const containerFile = await FileApi.GetFileInfo(file.Id);
		if (containerFile) {
			$fileInfoModal.value?.onOpen(
				containerFile,
				"file",
				undefined,
				undefined,
				file.Editable ?? false
			);
		}
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const downloadFile = (file: JobFile) => {
	if (!hasFileAccess.value || file.Editable === false) return

	try {
		FileApi.FileDownload(file.Id);
	} catch (e) {
		console.error(e)
	}
}

const getFileLocationTarget = (job: Job): { page: 'project' | 'client', id: number } | null => {
	if (job.Project) {
		return { page: 'project', id: job.Project.Id }
	}
	const firstClientId = job.Clients?.[0]?.Id
	if (firstClientId && firstClientId !== 1) {
		return { page: 'client', id: firstClientId }
	}
	return null
}

const goToFileLocation = (file: JobFile) => {
	if (!hasFileAccess.value) return

	const target = getFileLocationTarget(props.job)
	if (!target) return
	searchStoreInstance.requestFileSearch({
		type: target.page,
		id: target.id,
		fileName: file.Name,
		fileId: file.Id
	})
	const alreadyThere = route.query.page === target.page && Number(route.query.id) === target.id
	if (!alreadyThere) {
		router.push({ query: { ...route.query, page: target.page, id: target.id } })
	}
}

const triggerFileInput = () => {
	$uploadFile.value?.click()
}

const handleClick = () => {
	if (isJobsReadonly.value || !canManageJobFiles.value) {
		return
	}
	triggerFileInput()
}

const handleFileInput = async (event: Event) => {
	const target = event.target as HTMLInputElement
	if (!target.files || target.files.length === 0) {
		return
	}

	const accepted: File[] = []
	for (const file of Array.from(target.files)) {
		const validation = validateFile(file)
		if (!validation.isValid) {
			notify.danger(t('files_label'), validation.error!)
			continue
		}
		accepted.push(file)
	}
	target.value = ''
	if (accepted.length === 0) {
		return
	}

	let files = accepted
	if (files.length > MAX_FILES_PER_BATCH) {
		files = files.slice(0, MAX_FILES_PER_BATCH)
		notify.warning(t('files_label'), t('file_batch_limit', { count: MAX_FILES_PER_BATCH }))
	}
	enqueueDeviceUpload(files)
}

const showUserJobs = (userId: number) => {
	store.setUserForUpdateJobsList(userId)
}

const getJobStatusBarColor = (status: JobStatus) => {
	switch (status) {
		case JobStatus.Standard:
			return "#9A9C9E";
		case JobStatus.Working:
			return "#86CED2";
		case JobStatus.WaitingForCheck:
			return "#FFE7AA";
		case JobStatus.Completed:
			return "#6DA279";
		case JobStatus.Lost:
			return "#EE966A";
	}
}

const getSelfJobStatusBarColor = (status: JobStatus) => {
	switch (status) {
		case JobStatus.Standard:
			return "#97B2DE";
		case JobStatus.Working:
			return "#F1AC98";
		case JobStatus.WaitingForCheck:
			return "#C7C8C9";
		case JobStatus.Completed:
			return "#99BEA1";
		case JobStatus.Lost:
			return "#F6DB91";
	}
}

const jobStatusText = computed(() => {
	switch (props.job.Status) {
		case JobStatus.Standard:
			return t('job_state_system');
		case JobStatus.Working:
			return t('job_in_progress');
		case JobStatus.WaitingForCheck:
			return t('job_state_checking');
		case JobStatus.Completed:
			return t('job_state_completed');
		case JobStatus.Lost:
			return t('job_state_urgent');
		default:
			return "";
	}
})

const toDate = (date?: string | Date) => {
	if (!date) {
		return null;
	}
	return typeof date === "string" ? new Date(date) : date;
}

const formatDate = (date?: string | Date) => {
	const dateObj = toDate(date)
	if (!dateObj) {
		return "";
	}

	// Формат dd.MM.yy намеренно не зависит от локали: en-US дал бы MM/DD/YY,
	// и день с месяцем читались бы наоборот.
	const day = String(dateObj.getDate()).padStart(2, '0');
	const month = String(dateObj.getMonth() + 1).padStart(2, '0');
	const year = String(dateObj.getFullYear()).slice(-2);
	return `${day}.${month}.${year}`;
}

const formatDateTime = (date?: string | Date) => {
	const dateObj = toDate(date)
	if (!dateObj) {
		return "";
	}

	const hours = String(dateObj.getHours()).padStart(2, '0');
	const minutes = String(dateObj.getMinutes()).padStart(2, '0');
	return `${formatDate(dateObj)} ${hours}:${minutes}`;
}

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const worker = workerStore()

const showCommentInput = ref(false)
const commentMessage = ref('')
const pendingAction = ref<JobAction | null>(null)
const additionsExpanded = ref(false)
const $commentTextarea = ref<InstanceType<typeof AppCustomTextarea> | null>(null)

const isClientsExpanded = ref(false)

const displayedClients = computed(() =>
	isClientsExpanded.value || !props.job.Clients
		? props.job.Clients
		: props.job.Clients.slice(0, 1)
)

const userId = computed(() => worker.workerProfile?.Id)
const isAdmin = computed(() => worker.workerProfile?.IsAdmin ?? false)
const isCreator = computed(() => props.job.Creator?.Id === userId.value)
const isWorker = computed(() => props.job.Worker?.Id === userId.value)
const isSystemJob = computed(() => props.job.Status === JobStatus.Standard)

const dateState = computed(() => getJobDeadlineState(props.job))
const isDateLost = computed(() => dateState.value === 'lost')
const isDateSuccess = computed(() => dateState.value === 'success')

const dateTooltip = computed(() => {
	if (!props.job.CompletionDate) {
		return t('job_deadline')
	}
	// У завершённой работы на месте срока показана дата завершения, поэтому
	// исходный срок выносим в тултип
	return isDateLost.value
		? t('job_overdue_at', { date: formatDate(props.job.ToDoDate) })
		: t('job_state_completed')
})

const showCreatorName = computed(() =>
	!!props.job.Creator && props.job.Creator.Id !== props.job.Worker?.Id
)

const canEditJob = computed(() =>
	isCreator.value && props.job.Changeable && !props.job.FinishedByAdmin
)
const canDeleteJob = computed(() =>
	(isCreator.value && props.job.Changeable && !props.job.FinishedByAdmin)
	|| (isAdmin.value && !(isCreator.value && props.job.Changeable) && !props.job.FinishedByAdmin)
)

const isWorkingOrLost = computed(() =>
	props.job.Status === JobStatus.Working || props.job.Status === JobStatus.Lost
)

const isWaitingForCheck = computed(() =>
	props.job.Status === JobStatus.WaitingForCheck
)

// Случай 1: Исполнитель, с отчётом (sendToChecking)
const showSendToChecking = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && !isCreator.value && props.job.NeedChecking
)

// Случай 2: Исполнитель, без отчёта (endByWorker)
const showEndByWorkerNoMessage = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && !isCreator.value && !props.job.NeedChecking
)

// Случай 3: Исполнитель = Создатель, с отчётом (endByWorker с сообщением ИЛИ без)
const showSelfWorkerWithReport = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && isCreator.value && props.job.NeedChecking
)

// Случай 4: Исполнитель = Создатель, без отчёта (endByWorker без сообщения)
const showSelfWorkerNoReport = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && isCreator.value && !props.job.NeedChecking
)

// Случай 5: Инициатор проверяет (endByCreator + sendToReworking)
const showCreatorChecking = computed(() =>
	!showCommentInput.value && isWaitingForCheck.value && isCreator.value && !isWorker.value
)

// Случай 6: Админ завершает (чистый админ — не creator и не worker)
const showAdminEnd = computed(() =>
	!showCommentInput.value && isAdmin.value && !isCreator.value && !isWorker.value
	&& (isWorkingOrLost.value || isWaitingForCheck.value)
)

// Админ + участник работы: кнопка FinishAsAdmin добавочная к основным
// (a) Worker+Admin+NeedChecking+Working/Lost — рядом с SendToChecking
// (b) Creator(only)+Admin+Working/Lost — одиночная кнопка
// (c) Worker+Admin+NeedChecking+Checking
const showAdminEndExtra = computed(() => {
	if (showCommentInput.value || !isAdmin.value) return false
	if (isWorkingOrLost.value && isWorker.value && !isCreator.value && props.job.NeedChecking) return true
	if (isWorkingOrLost.value && isCreator.value && !isWorker.value) return true
	if (isWaitingForCheck.value && isWorker.value && !isCreator.value && props.job.NeedChecking) return true
	return false
})

const hasActionButtons = computed(() =>
	showSendToChecking.value || showEndByWorkerNoMessage.value || showSelfWorkerWithReport.value
	|| showSelfWorkerNoReport.value || showCreatorChecking.value || showAdminEnd.value
	|| showAdminEndExtra.value
)

const commentLabel = computed(() => {
	switch (pendingAction.value) {
		case 'endByWorker': return `${t('job_comment_label_finish')}:`
		case 'sendToChecking': return `${t('job_comment_label_report')}:`
		case 'sendToReworking': return `${t('job_action_rework')}:`
		case 'endByAdmin': return `${t('job_comment_label_finish')}:`
		default: return ''
	}
})

const startAction = (action: JobAction) => {
	showCommentInput.value = true
	pendingAction.value = action
	commentMessage.value = ''
}

const directAction = async (action: 'endByWorker' | 'endByCreator' | 'endByAdmin') => {
	try {
		isLoading.value = true
		await store.changeJobStatus(props.job.Id, action)
	} finally {
		isLoading.value = false
	}
}

const submitAction = async () => {
	if (!pendingAction.value || !commentMessage.value.trim()) return
	const message = trimTrailingLineBreaks(commentMessage.value)
		.replace(/\n/g, '<br/>')
	const action = pendingAction.value
	cancelAction()
	try {
		isLoading.value = true
		await store.changeJobStatus(props.job.Id, action, message)
	} finally {
		isLoading.value = false
	}
}

const cancelAction = () => {
	showCommentInput.value = false
	commentMessage.value = ''
	pendingAction.value = null
	$commentTextarea.value?.reset()
}

const handleDelete = () => {
	$optionsDropdown.value?.close()
	$deleteJobDropdown.value?.open()
}

const onConfirmDelete = async () => {
	$deleteJobDropdown.value?.close()
	try {
		isLoading.value = true
		await store.deleteJob(props.job.Id)
	} finally {
		isLoading.value = false
	}
}

// Завершение работы администратором: с сообщением если NeedChecking, иначе сразу
const handleAdminEnd = () => {
	if (props.job.NeedChecking) {
		startAction('endByAdmin')
	} else {
		directAction('endByAdmin')
	}
}

const handleShowInfo = () => {
	$jobInfoModal.value?.onOpen(props.job.Id)
}

const splitMessageByBr = (input: string | null | undefined): string[] => {
	if (!input) return []

	return input.split(/<br\s*\/?>|\r?\n/gi)
}

const searchText = computed(() => store.lastFilters.textFilter ?? '')

const buildMessageSegments = (message: string | null | undefined) =>
	splitMessageByBr(message).map(line =>
		splitTextByPhoneNumbers(line, searchText.value).map(el =>
			(el.isPhone || el.isEmail || el.isUrl)
				? el
				: { ...el, text: highlightSearchText(searchText.value, escapeHtml(el.text)) }
		)
	)

const messageSegments = computed(() => buildMessageSegments(props.job.Message))

const additionsSegments = computed(() =>
	(props.job.Additions ?? []).map(addition => ({
		addition,
		lines: buildMessageSegments(addition.Message)
	}))
)

const callPhone = async (phoneNumber: string) => {
	const clearNumber = encodeURIComponent(stripHighlightMarkup(phoneNumber))
	await PersonApi.callPhone(clearNumber)
}

const onEmail = (email: string) => {
	const link = document.createElement('a')
	link.href = `mailto:${stripHighlightMarkup(email)}`
	link.style.display = 'none'
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

const openUrlInNewTab = (url: string) => {
	window.open(normalizeUrlForOpening(stripHighlightMarkup(url)), '_blank', 'noopener,noreferrer')
}

const onCopyPhoneAndEmail = (text: string) => {
	const textArea = document.createElement('textarea')
	textArea.value = stripHighlightMarkup(text)
	textArea.style.position = 'fixed'
	textArea.style.left = '-999999px'
	textArea.style.top = '-999999px'
	document.body.appendChild(textArea)
	textArea.focus()
	textArea.select()
	try {
		document.execCommand('copy')
	} catch (err) {
		console.error('Не удалось скопировать текст: ', err)
	}
	document.body.removeChild(textArea)
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FileInfoModal, {
      ref_key: "$fileInfoModal",
      ref: $fileInfoModal,
      title: _ctx.$t('file_information_and_access'),
      "rule-access": fileAccessLevel.value
    }, null, 8, ["title", "rule-access"]),
    _createVNode(JobInfoModal, {
      ref_key: "$jobInfoModal",
      ref: $jobInfoModal
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "$job",
      ref: $job,
      "data-job-id": props.job.Id,
      class: _normalizeClass({
			'jobs-panel-list-item': true,
            'jobs-panel-list-item--is-dragging-over': _unref(isDraggingOver),
            'jobs-panel-list-item--can-drop': _unref(canDrop) && _unref(isDraggingOver),
            'jobs-panel-list-item--cannot-drop': !_unref(canDrop) && _unref(isDraggingOver)
		}),
      onDragover: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(handleDragOver) && _unref(handleDragOver)(...args))),
      onDragenter: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(handleDragEnter) && _unref(handleDragEnter)(...args))),
      onDragleave: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(handleDragLeave) && _unref(handleDragLeave)(...args))),
      onDrop: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_unref(handleDrop) && _unref(handleDrop)(...args)))
    }, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
				'jobs-panel-list-item__drop-zone': true,
				'jobs-panel-list-item__drop-zone--can-drop': _unref(canDrop) && _unref(isDraggingOver),
				'jobs-panel-list-item__drop-zone--cannot-drop': !_unref(canDrop) && _unref(isDraggingOver),
			})
      }, null, 2),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppTooltip, {
          text: jobStatusText.value,
          disabled: !jobStatusText.value,
          position: "left"
        }, {
          activator: _withCtx(() => [
            _createElementVNode("div", {
              class: "jobs-panel-list-item__colored",
              style: _normalizeStyle({ backgroundColor: getJobStatusBarColor(props.job.Status) })
            }, null, 4)
          ]),
          _: 1
        }, 8, ["text", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "jobs-panel-list-item__header-worker",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showUserJobs(props.job.Worker.Id)))
          }, _toDisplayString(props.job.Worker.Name), 1),
          (showCreatorName.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(AppIcon, {
                    class: "jobs-panel-list-item__header-options-btn",
                    name: "chevron-left",
                    width: "16px",
                    color: "#499259"
                  })
                ]),
                _createElementVNode("div", {
                  class: "jobs-panel-list-item__header-worker",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showUserJobs(props.job.Creator.Id)))
                }, _toDisplayString(props.job.Creator.Name), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (hasActionButtons.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (showSendToChecking.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 0,
                      text: _ctx.$t('job_action_send_to_checking')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "send-to-check",
                          width: "18px",
                          color: "#F9C22F",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (startAction('sendToChecking')))
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (showEndByWorkerNoMessage.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 1,
                      text: _ctx.$t('job_action_finish')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "check-circle",
                          width: "18px",
                          color: "#607D8B",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (directAction('endByWorker')))
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (showSelfWorkerWithReport.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 2,
                      text: _ctx.$t('job_action_finish_with_report')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "check-circle",
                          width: "18px",
                          color: "#607D8B",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (startAction('endByWorker')))
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (showSelfWorkerNoReport.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 3,
                      text: _ctx.$t('job_action_finish')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "check-circle",
                          width: "18px",
                          color: "#607D8B",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (directAction('endByWorker')))
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (showCreatorChecking.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('job_action_accept')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "check-circle",
                            width: "18px",
                            color: "#607D8B",
                            "hover-color": "#3F884F",
                            cursor: "pointer",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (directAction('endByCreator')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]),
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('job_action_rework')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "back-to-rework",
                            width: "18px",
                            color: "#F9C22F",
                            "hover-color": "#3F884F",
                            cursor: "pointer",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (startAction('sendToReworking')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ], 64))
                  : _createCommentVNode("", true),
                (showAdminEnd.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 5,
                      text: _ctx.$t('job_action_finish_as_admin')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "end-by-admin",
                          width: "18px",
                          color: "#607D8B",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: handleAdminEnd
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (showAdminEndExtra.value)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 6,
                      text: _ctx.$t('job_action_finish_as_admin')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "end-by-admin",
                          width: "18px",
                          color: "#607D8B",
                          "hover-color": "#3F884F",
                          cursor: "pointer",
                          onClick: handleAdminEnd
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(AppResizableDropdown, {
            ref_key: "$optionsDropdown",
            ref: $optionsDropdown,
            position: "right",
            trigger: "hover",
            "hover-delay": 100,
            "mobile-title": _ctx.$t('contact_choose_action')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "jobs-panel-list-item__header-options-btn",
                name: "options-menu",
                height: "18px",
                width: "22px",
                color: "#979797",
                "hover-color": "#3F884F",
                cursor: "pointer"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(JobsOptionsDropdown, {
                job: props.job,
                "show-send-to-checking": showSendToChecking.value,
                "show-end-by-worker": showEndByWorkerNoMessage.value || showSelfWorkerNoReport.value,
                "show-end-by-worker-with-message": showSelfWorkerWithReport.value,
                "show-end-by-creator": showCreatorChecking.value,
                "show-send-to-reworking": showCreatorChecking.value,
                "show-end-by-admin": showAdminEnd.value || showAdminEndExtra.value,
                "show-edit": canEditJob.value,
                "show-delete": canDeleteJob.value,
                onOnSendToChecking: _cache[8] || (_cache[8] = ($event: any) => (startAction('sendToChecking'))),
                onOnEndByWorker: _cache[9] || (_cache[9] = ($event: any) => (directAction('endByWorker'))),
                onOnEndByWorkerWithMessage: _cache[10] || (_cache[10] = ($event: any) => (startAction('endByWorker'))),
                onOnEndByCreator: _cache[11] || (_cache[11] = ($event: any) => (directAction('endByCreator'))),
                onOnSendToReworking: _cache[12] || (_cache[12] = ($event: any) => (startAction('sendToReworking'))),
                onOnEndByAdmin: handleAdminEnd,
                onOnShowInfo: handleShowInfo,
                onOnEdit: handleEdit,
                onOnDelete: handleDelete
              }, null, 8, ["job", "show-send-to-checking", "show-end-by-worker", "show-end-by-worker-with-message", "show-end-by-creator", "show-send-to-reworking", "show-end-by-admin", "show-edit", "show-delete"])
            ]),
            _: 1
          }, 8, ["mobile-title"]),
          _createVNode(AppResizableDropdown, {
            ref_key: "$editJobDropdown",
            ref: $editJobDropdown,
            name: "$editJobDropdown",
            position: "right",
            resizable: "",
            "initial-width": 320,
            "initial-height": 398,
            "min-width": 320,
            "max-width": 480,
            "min-height": 398,
            "max-height": 600,
            "close-by-click-outside": false,
            "hide-by-parent-scroll": false,
            "mobile-title": _ctx.$t('job_edit_title')
          }, {
            activator: _withCtx(() => _cache[24] || (_cache[24] = [
              _createElementVNode("span", { class: "jobs-panel-list-item__edit-anchor" }, null, -1)
            ])),
            default: _withCtx(() => [
              _createVNode(CreateEditJobDropdown, {
                type: "edit",
                job: props.job,
                workers: _unref(optionsPersons),
                onOnClose: _cache[13] || (_cache[13] = ($event: any) => ($editJobDropdown.value?.close()))
              }, null, 8, ["job", "workers"])
            ]),
            _: 1
          }, 8, ["mobile-title"]),
          _createVNode(AppResizableDropdown, {
            ref_key: "$deleteJobDropdown",
            ref: $deleteJobDropdown,
            position: "right",
            "centered-on-mobile": ""
          }, {
            activator: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("span", { class: "jobs-panel-list-item__edit-anchor" }, null, -1)
            ])),
            default: _withCtx(() => [
              _createVNode(DeleteJobConfirmDropdown, {
                onCancel: _cache[14] || (_cache[14] = ($event: any) => ($deleteJobDropdown.value?.close())),
                onConfirm: onConfirmDelete
              })
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageSegments.value, (segments, lineIdx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: lineIdx }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments, (el, elIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: elIdx }, [
                  (el.isPhone)
                    ? (_openBlock(), _createBlock(AppResizableDropdown, {
                        key: 0,
                        position: "bottom",
                        trigger: "hover",
                        "initial-width": 125,
                        "initial-height": 62,
                        "mobile-title": _ctx.$t('contact_choose_action')
                      }, {
                        activator: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "jobs-panel-list-item__body-phone",
                            onClick: _withModifiers(($event: any) => (callPhone(el.text)), ["stop"]),
                            innerHTML: el.text
                          }, null, 8, _hoisted_10)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(ContactsEmailPhoneOptionsDropdown, {
                            type: "phone",
                            onOnCall: ($event: any) => (callPhone(el.text)),
                            onOnCopy: ($event: any) => (onCopyPhoneAndEmail(el.text))
                          }, null, 8, ["onOnCall", "onOnCopy"])
                        ]),
                        _: 2
                      }, 1032, ["mobile-title"]))
                    : (el.isEmail)
                      ? (_openBlock(), _createBlock(AppResizableDropdown, {
                          key: 1,
                          position: "bottom",
                          trigger: "hover",
                          "initial-width": 125,
                          "initial-height": 62,
                          "mobile-title": _ctx.$t('contact_choose_action')
                        }, {
                          activator: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "jobs-panel-list-item__body-email",
                              onClick: _withModifiers(($event: any) => (onEmail(el.text)), ["stop","prevent"]),
                              innerHTML: el.text
                            }, null, 8, _hoisted_11)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(ContactsEmailPhoneOptionsDropdown, {
                              type: "email",
                              onOnEmail: ($event: any) => (onEmail(el.text)),
                              onOnCopy: ($event: any) => (onCopyPhoneAndEmail(el.text))
                            }, null, 8, ["onOnEmail", "onOnCopy"])
                          ]),
                          _: 2
                        }, 1032, ["mobile-title"]))
                      : (el.isUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "jobs-panel-list-item__body-url",
                            href: _unref(normalizeUrlForOpening)(_unref(stripHighlightMarkup)(el.text)),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: _withModifiers(($event: any) => (openUrlInNewTab(el.text)), ["stop","prevent"]),
                            innerHTML: el.text
                          }, null, 8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            innerHTML: el.text
                          }, null, 8, _hoisted_13))
                ], 64))
              }), 128)),
              (lineIdx < messageSegments.value.length - 1)
                ? (_openBlock(), _createElementBlock("br", _hoisted_14))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        (props.job.Additions?.length >= 2 && !additionsExpanded.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "jobs-panel-list-item__additions-collapsed",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (additionsExpanded.value = true))
            }, [
              _createVNode(AppIcon, {
                name: "plus-circle",
                width: "16px",
                color: "#979797",
                cursor: "pointer"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$tc('job_comments_count', props.job.Additions.length ?? 0)), 1)
            ]))
          : (props.job.Additions?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionsSegments.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.addition.Date,
                    class: "jobs-panel-list-item__addition"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.addition.Username), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(formatDateTime(item.addition.Date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("b", _hoisted_20, _toDisplayString(item.addition.Title), 1),
                      _cache[26] || (_cache[26] = _createTextVNode(" ")),
                      _createElementVNode("span", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lines, (segments, lineIdx) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: lineIdx }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments, (el, elIdx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: elIdx }, [
                                (el.isPhone)
                                  ? (_openBlock(), _createBlock(AppResizableDropdown, {
                                      key: 0,
                                      position: "bottom",
                                      trigger: "hover",
                                      "initial-width": 125,
                                      "initial-height": 62,
                                      "mobile-title": _ctx.$t('contact_choose_action')
                                    }, {
                                      activator: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: "jobs-panel-list-item__body-phone",
                                          onClick: _withModifiers(($event: any) => (callPhone(el.text)), ["stop"]),
                                          innerHTML: el.text
                                        }, null, 8, _hoisted_21)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(ContactsEmailPhoneOptionsDropdown, {
                                          type: "phone",
                                          onOnCall: ($event: any) => (callPhone(el.text)),
                                          onOnCopy: ($event: any) => (onCopyPhoneAndEmail(el.text))
                                        }, null, 8, ["onOnCall", "onOnCopy"])
                                      ]),
                                      _: 2
                                    }, 1032, ["mobile-title"]))
                                  : (el.isEmail)
                                    ? (_openBlock(), _createBlock(AppResizableDropdown, {
                                        key: 1,
                                        position: "bottom",
                                        trigger: "hover",
                                        "initial-width": 125,
                                        "initial-height": 62,
                                        "mobile-title": _ctx.$t('contact_choose_action')
                                      }, {
                                        activator: _withCtx(() => [
                                          _createElementVNode("a", {
                                            class: "jobs-panel-list-item__body-email",
                                            onClick: _withModifiers(($event: any) => (onEmail(el.text)), ["stop","prevent"]),
                                            innerHTML: el.text
                                          }, null, 8, _hoisted_22)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(ContactsEmailPhoneOptionsDropdown, {
                                            type: "email",
                                            onOnEmail: ($event: any) => (onEmail(el.text)),
                                            onOnCopy: ($event: any) => (onCopyPhoneAndEmail(el.text))
                                          }, null, 8, ["onOnEmail", "onOnCopy"])
                                        ]),
                                        _: 2
                                      }, 1032, ["mobile-title"]))
                                    : (el.isUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "jobs-panel-list-item__body-url",
                                          href: _unref(normalizeUrlForOpening)(_unref(stripHighlightMarkup)(el.text)),
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          onClick: _withModifiers(($event: any) => (openUrlInNewTab(el.text)), ["stop","prevent"]),
                                          innerHTML: el.text
                                        }, null, 8, _hoisted_23))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 3,
                                          innerHTML: el.text
                                        }, null, 8, _hoisted_24))
                              ], 64))
                            }), 128)),
                            (lineIdx < item.lines.length - 1)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_25))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
        (showCommentInput.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "jobs-panel-list-item__comment",
              onKeydown: _withKeys(cancelAction, ["escape"])
            }, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(commentLabel.value), 1),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(AppCustomTextarea, {
                  ref_key: "$commentTextarea",
                  ref: $commentTextarea,
                  modelValue: commentMessage.value,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((commentMessage).value = $event)),
                  placeholder: _ctx.$t('ui_enter_text'),
                  "min-height": 32,
                  "max-height": 200,
                  "auto-focus": true,
                  onCtrlEnter: submitAction
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(AppTooltip, {
                  text: _ctx.$t('ui_cancel')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "close-bold",
                      width: "16px",
                      color: "#979797",
                      "hover-color": "#BA4C4C",
                      cursor: "pointer",
                      style: { marginTop: '-4px' },
                      onClick: cancelAction
                    })
                  ]),
                  _: 1
                }, 8, ["text"]),
                _createVNode(AppTooltip, {
                  text: _ctx.$t('send_message')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "send-message",
                      width: "16px",
                      color: "#979797",
                      "hover-color": "#499259",
                      cursor: "pointer",
                      style: { marginTop: '-4px' },
                      onClick: submitAction
                    })
                  ]),
                  _: 1
                }, 8, ["text"])
              ])
            ], 32))
          : _createCommentVNode("", true),
        (props.job.Project)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('project_label')) + ": ", 1),
              _createVNode(_component_router_link, {
                class: "jobs-panel-list-item__body-project-link",
                to: { query: { page: 'project', id: props.job.Project.Id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _unref(highlightSearchText)(searchText.value, _unref(escapeHtml)(props.job.Project.Name))
                  }, null, 8, _hoisted_30)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
        (props.job.Clients)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t(props.job.Clients.length === 1 ? 'client_label' : 'clients_label')) + ": ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedClients.value, (client, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: client.Id
                }, [
                  _createVNode(_component_router_link, {
                    class: "jobs-panel-list-item__body-project-link",
                    to: { query: { page: 'client', id: client.Id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _unref(highlightSearchText)(searchText.value, _unref(escapeHtml)(client.Name))
                      }, null, 8, _hoisted_33)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (index + 1 < displayedClients.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, " / "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (!isClientsExpanded.value && props.job.Clients.length > 1)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "jobs-panel-list-item__body-project-show-more",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (isClientsExpanded.value = true))
                  }, _toDisplayString(_ctx.$t('more_count_label', { count: props.job.Clients.length - 1 })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", {
            class: _normalizeClass({
					'jobs-panel-list-item__footer-left-options': true,
					'jobs-panel-list-item__footer-left-options--have-files': props.job.Files?.length,
				})
          }, [
            _createElementVNode("div", {
              class: "jobs-panel-list-item__footer-left-options-files-block",
              style: _normalizeStyle({ marginTop:  props.job.Files?.length ? '4px' : '0' })
            }, [
              _createElementVNode("input", {
                ref_key: "$uploadFile",
                ref: $uploadFile,
                type: "file",
                class: "upload-block__input",
                multiple: "",
                onChange: handleFileInput
              }, null, 544),
              (!_unref(isJobsReadonly) && canManageJobFiles.value)
                ? (_openBlock(), _createBlock(AppTooltip, {
                    key: 0,
                    text: _ctx.$t('file_upload')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "jobs-panel-list-item__header-options-btn",
                        name: "clip",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: handleClick
                      })
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : (_openBlock(), _createBlock(AppIcon, {
                    key: 1,
                    class: "jobs-panel-list-item__header-options-btn",
                    name: "clip",
                    width: "18px",
                    color: "#D2D2D2"
                  })),
              (props.job.Files?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(!showAllFiles.value
										? props.job.Files.slice(0, 2)
										: props.job.Files, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "jobs-panel-list-item__footer-left-options-files-block-item",
                        key: file.Id
                      }, [
                        _createVNode(AppTooltip, {
                          text: _ctx.$t('information')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "jobs-panel-list-item__header-options-btn",
                              style: { marginRight: '2px' },
                              name: "info-circle-outline",
                              width: "18px",
                              color: hasFileAccess.value ? '#979797' : '#D2D2D2',
                              "hover-color": hasFileAccess.value ? '#499259' : undefined,
                              cursor: hasFileAccess.value ? 'pointer' : 'default',
                              onClick: ($event: any) => (showFileInfo(file))
                            }, null, 8, ["color", "hover-color", "cursor", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["text"]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["jobs-panel-list-item__footer-left-options-files-block-item-name", {'jobs-panel-list-item__footer-left-options-files-block-item-name-disable': !hasFileAccess.value || file.Editable === false}]),
                          onClick: ($event: any) => (downloadFile(file))
                        }, _toDisplayString(file.Name), 11, _hoisted_38),
                        (!_unref(isJobsReadonly) && hasFileAccess.value && file.Editable)
                          ? (_openBlock(), _createBlock(AppTooltip, {
                              key: 0,
                              text: _ctx.$t('file_detach')
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  class: "jobs-panel-list-item__footer-left-options-tag-delete",
                                  style: { marginRight: '4px', marginLeft: '2px' },
                                  name: "close-bold",
                                  width: "12px",
                                  color: "#D2D2D2",
                                  "hover-color": "#BA4C4C",
                                  cursor: "pointer",
                                  onClick: ($event: any) => (detachFile(file))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"]))
                          : _createCommentVNode("", true),
                        (hasFileAccess.value && getFileLocationTarget(props.job))
                          ? (_openBlock(), _createBlock(AppTooltip, {
                              key: 1,
                              text: _ctx.$t('file_go_to_location')
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  class: "jobs-panel-list-item__header-options-btn",
                                  name: "arrow-45deg",
                                  width: "18px",
                                  color: "#979797",
                                  "hover-color": "#499259",
                                  cursor: "pointer",
                                  onClick: ($event: any) => (goToFileLocation(file))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"]))
                          : _createCommentVNode("", true),
                        (props.job.Files.length > 2 && index === 1 && !showAllFiles.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "jobs-panel-list-item__footer-left-options-files-block-item-more",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (showAllFiles.value = true))
                            }, _toDisplayString(_ctx.$t('more_count_label', { count: props.job.Files.length - 2 })), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", {
              class: _normalizeClass({
						'jobs-panel-list-item__footer-left-options-tags-block': true,
						'jobs-panel-list-item__footer-left-options-tags-block--with-date': isSystemJob.value,
					})
            }, [
              (!_unref(isJobsReadonly))
                ? (_openBlock(), _createBlock(AppResizableDropdown, {
                    key: 0,
                    ref_key: "$addTagDropdown",
                    ref: $addTagDropdown,
                    position: "right",
                    "close-by-click-outside": true,
                    "max-width": 640,
                    "max-height": 460,
                    "mobile-title": _ctx.$t('choose_tags')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('file_add_tag')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "jobs-panel-list-item__header-options-btn",
                            name: "hash",
                            width: "18px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(AppTagSelector, {
                        "model-value": jobTagsModel.value,
                        "entity-type": _unref(TagEntityType).Job,
                        mode: "select",
                        "allow-create": "",
                        "onUpdate:modelValue": onTagSelectorChange,
                        onCreateTag: onCreateTag,
                        onClose: _cache[19] || (_cache[19] = ($event: any) => ($addTagDropdown.value?.close()))
                      }, null, 8, ["model-value", "entity-type"])
                    ]),
                    _: 1
                  }, 8, ["mobile-title"]))
                : (_openBlock(), _createBlock(AppIcon, {
                    key: 1,
                    class: "jobs-panel-list-item__header-options-btn",
                    name: "hash",
                    width: "18px",
                    color: "#979797"
                  })),
              (props.job.Tags && props.job.Tags.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    (!_unref(isJobsReadonly))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.job.Tags, (tag) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tag.Id,
                            class: "jobs-panel-list-item__footer-left-options-tag"
                          }, [
                            _createTextVNode(_toDisplayString(tag.Name.toLowerCase()) + " ", 1),
                            _createVNode(AppTooltip, {
                              text: _ctx.$t('ui_tag_detach')
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  class: "jobs-panel-list-item__footer-left-options-tag-delete",
                                  style: { marginLeft: '2px' },
                                  name: "close-bold",
                                  width: "12px",
                                  color: "#D2D2D2",
                                  "hover-color": "#BA4C4C",
                                  cursor: "pointer",
                                  onClick: ($event: any) => (onDetachTag(tag.Id))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(tagsReadonlyText.value), 1))
                  ]))
                : _createCommentVNode("", true),
              (isSystemJob.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(formatDateTime(props.job.CreateTime)), 1))
                : _createCommentVNode("", true)
            ], 2)
          ], 2)
        ]),
        (!isSystemJob.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createVNode(AppTooltip, { text: dateTooltip.value }, {
                activator: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({
								'jobs-panel-list-item__footer-bottom-date': true,
								'jobs-panel-list-item__footer-bottom-date--lost': isDateLost.value,
								'jobs-panel-list-item__footer-bottom-date--success': isDateSuccess.value
							})
                  }, [
                    _createVNode(AppIcon, {
                      class: "jobs-panel-list-item__footer-bottom-date-clock",
                      name: "clock",
                      width: "16px"
                    }),
                    (props.job.CompletionDate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(formatDateTime(props.job.CompletionDate)), 1)
                        ], 64))
                      : (props.job.ToDoDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatDate(props.job.ToDoDate)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["text"]),
              _createElementVNode("span", null, _toDisplayString(formatDateTime(props.job.CreateTime)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 42, _hoisted_1)
  ], 64))
}
}

})